import {
  httpGet,
  httpPost,
  httpPut,
  httpPatch,
  httpDelete,
} from "../../utils/httpMethods";
import { NEWSLETTER_URL } from '../restEndpoint';
import * as Sentry from "@sentry/react";

const { logger } = Sentry;

// Newsletter Campaign APIs
export const getAllCampaigns = async () => {
  return await httpGet({ url: `${NEWSLETTER_URL}/campaigns` })
    .then((res) => {
      logger.debug("Get all campaigns successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Get all campaigns error", { error: err.message });
      return err?.response;
    });
};

export const getCampaignById = async (id) => {
  return await httpGet({ url: `${NEWSLETTER_URL}/campaigns/${id}` })
    .then((res) => {
      logger.debug("Get campaign by ID successful", { id });
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Get campaign by ID error", { id, error: err.message });
      return err?.response;
    });
};

export const createCampaign = async (campaignData) => {
  return await httpPost({
    url: `${NEWSLETTER_URL}/campaigns`,
    payload: campaignData,
  })
    .then((res) => {
      logger.debug("Create campaign successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Create campaign error", { error: err.message });
      return err?.response;
    });
};

export const updateCampaign = async (id, campaignData) => {
  return await httpPut({
    url: `${NEWSLETTER_URL}/campaigns/${id}`,
    payload: campaignData,
  })
    .then((res) => {
      logger.debug("Update campaign successful", { id });
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Update campaign error", { id, error: err.message });
      return err?.response;
    });
};

export const deleteCampaign = async (id) => {
  return await httpDelete({ url: `${NEWSLETTER_URL}/campaigns/${id}` })
    .then((res) => {
      logger.debug("Delete campaign successful", { id });
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Delete campaign error", { id, error: err.message });
      return err?.response;
    });
};

export const sendCampaign = async (id, payload = {}) => {
  return await httpPost({
    url: `${NEWSLETTER_URL}/campaigns/${id}/send`,
    payload: payload,
  })
    .then((res) => {
      logger.debug("Send campaign successful", { id });
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Send campaign error", { id, error: err.message });
      return err?.response;
    });
};

export const scheduleCampaign = async (id, scheduleData) => {
  return await httpPost({
    url: `${NEWSLETTER_URL}/campaigns/${id}/schedule`,
    payload: scheduleData,
  })
    .then((res) => {
      logger.debug("Schedule campaign successful", { id });
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Schedule campaign error", { id, error: err.message });
      return err?.response;
    });
};

export const getCampaignAnalytics = async (id) => {
  return await httpGet({ url: `${NEWSLETTER_URL}/campaigns/${id}/analytics` })
    .then((res) => {
      logger.debug("Get campaign analytics successful", { id });
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Get campaign analytics error", { id, error: err.message });
      return err?.response;
    });
};

// Email Template APIs
export const getAllTemplates = async () => {
  return await httpGet({ url: `${NEWSLETTER_URL}/templates` })
    .then((res) => {
      logger.debug("Get all templates successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Get all templates error", { error: err.message });
      return err?.response;
    });
};

export const getTemplateById = async (id) => {
  return await httpGet({ url: `${NEWSLETTER_URL}/templates/${id}` })
    .then((res) => {
      logger.debug("Get template by ID successful", { id });
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Get template by ID error", { id, error: err.message });
      return err?.response;
    });
};

export const createTemplate = async (templateData) => {
  return await httpPost({
    url: `${NEWSLETTER_URL}/templates`,
    payload: templateData,
  })
    .then((res) => {
      logger.debug("Create template successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Create template error", { error: err.message });
      return err?.response;
    });
};

export const updateTemplate = async (id, templateData) => {
  return await httpPut({
    url: `${NEWSLETTER_URL}/templates/${id}`,
    payload: templateData,
  })
    .then((res) => {
      logger.debug("Update template successful", { id });
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Update template error", { id, error: err.message });
      return err?.response;
    });
};

export const deleteTemplate = async (id) => {
  return await httpDelete({ url: `${NEWSLETTER_URL}/templates/${id}` })
    .then((res) => {
      logger.debug("Delete template successful", { id });
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Delete template error", { id, error: err.message });
      return err?.response;
    });
};

// Audience APIs
export const getAudienceStats = async () => {
  return await httpGet({ url: `${NEWSLETTER_URL}/audience/stats` })
    .then((res) => {
      logger.debug("Get audience stats successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Get audience stats error", { error: err.message });
      return err?.response;
    });
};

export const getAudienceSegments = async () => {
  return await httpGet({ url: `${NEWSLETTER_URL}/audience/segments` })
    .then((res) => {
      logger.debug("Get audience segments successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Get audience segments error", { error: err.message });
      return err?.response;
    });
};

export const createAudienceSegment = async (segmentData) => {
  return await httpPost({
    url: `${NEWSLETTER_URL}/audience/segments`,
    payload: segmentData,
  })
    .then((res) => {
      logger.debug("Create audience segment successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Create audience segment error", { error: err.message });
      return err?.response;
    });
};

// User Email Preferences APIs
export const getUserEmailPreferences = async (userId) => {
  return await httpGet({ url: `${NEWSLETTER_URL}/users/${userId}/email-preferences` })
    .then((res) => {
      logger.debug("Get user email preferences successful", { userId });
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Get user email preferences error", { userId, error: err.message });
      return err?.response;
    });
};

export const updateUserEmailPreferences = async (userId, preferences) => {
  return await httpPut({
    url: `${NEWSLETTER_URL}/users/${userId}/email-preferences`,
    payload: preferences,
  })
    .then((res) => {
      logger.debug("Update user email preferences successful", { userId });
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Update user email preferences error", { userId, error: err.message });
      return err?.response;
    });
};

export const unsubscribeUser = async (userId, campaignType) => {
  return await httpPost({
    url: `${NEWSLETTER_URL}/users/${userId}/unsubscribe`,
    payload: { campaignType },
  })
    .then((res) => {
      logger.debug("Unsubscribe user successful", { userId, campaignType });
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Unsubscribe user error", { userId, campaignType, error: err.message });
      return err?.response;
    });
};

// Newsletter Analytics APIs
export const getNewsletterAnalytics = async (dateRange) => {
  const params = dateRange ? new URLSearchParams(dateRange).toString() : '';
  const url = params ? `${NEWSLETTER_URL}/analytics?${params}` : `${NEWSLETTER_URL}/analytics`;
  
  return await httpGet({ url })
    .then((res) => {
      logger.debug("Get newsletter analytics successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Get newsletter analytics error", { error: err.message });
      return err?.response;
    });
};

export const getCampaignPerformance = async (campaignId) => {
  return await httpGet({ url: `${NEWSLETTER_URL}/campaigns/${campaignId}/performance` })
    .then((res) => {
      logger.debug("Get campaign performance successful", { campaignId });
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Get campaign performance error", { campaignId, error: err.message });
      return err?.response;
    });
};

export const getEmailDeliverability = async () => {
  return await httpGet({ url: `${NEWSLETTER_URL}/deliverability` })
    .then((res) => {
      logger.debug("Get email deliverability successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Get email deliverability error", { error: err.message });
      return err?.response;
    });
};

// Preview Campaign Email Template
export const previewCampaignEmail = async (campaignData) => {
  return await httpPost({
    url: `${NEWSLETTER_URL}/preview-template`,
    payload: campaignData,
  })
    .then((res) => {
      logger.debug("Preview campaign email successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Preview campaign email error", { error: err.message });
      return err?.response;
    });
};